import React from 'react';

const Divider = ({ style }) => {
  return <div className="divider" style={{ ...style }}></div>;
};

export default Divider;
